import { render } from "./SearchFunction.vue?vue&type=template&id=4efbbc34"
import script from "./SearchFunction.vue?vue&type=script&lang=js"
export * from "./SearchFunction.vue?vue&type=script&lang=js"

import "./SearchFunction.vue?vue&type=style&index=0&id=4efbbc34&lang=css"

import exportComponent from "/builds/cu2207/business/produkter.dk/pfp-public-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__